/******************************************************************************************
 *	Customers List Call Payload
 *******************************************************************************************
 *
 * API for the payload added to calls that fetch customers.
 * Can set page, sort, filter and search.
 *
 */
(function() {
  

  angular.module('rcServices.payload', []).service(
    'Payload',
    /* @ngInject */
    function(_, Settings, PLAN_TYPE) {
      var payload = {
        page: 1,
        itemsPerPage: Settings.itemsPerPage.default
      };

      /*=== Generic ===*/
      this.get = function() {
        return payload;
      };
      this.set = function(data) {
        payload = data;
      };

      //Clear data that should not be persisted between segments like paging and sorting.
      //Others, like "Managed by me" filter, need to be persisted between segments.
      this.clear = function() {
        payload.page = 1;
        this.clearSort();
      };

      //Completely reset the payload
      this.reset = function() {
        payload = {
          page: 1,
          itemsPerPage: Settings.itemsPerPage.default
        };
      };

      /*=== Paging ===*/
      this.setPage = function(page) {
        payload.page = page;
      };

      this.getPage = function() {
        return payload.page;
      };

      /*=== Sorting ===*/
      this.setSort = function(columns, direction) {
        if (direction === 'desc') {
          //Add minus in front of all columns
          payload.sort = '-' + _.split(columns, ',').join(',-');
        } else {
          payload.sort = columns;
        }
      };

      this.getSort = function() {
        return payload.sort;
      };

      this.clearSort = function() {
        delete payload.sort;
      };

      /*=== Searching ===*/
      this.setSearch = function(query, field) {
        payload.q = query;
        if (field) {
          payload.qField = field;
        } else {
          delete payload.qField;
        }
      };
      this.getSearch = function() {
        return {
          query: payload.q,
          field: payload.qField
        };
      };
      //Returns the search as a string formed as 'field: query' if field is set or simply 'query' otherwise
      this.getSearchAsString = function() {
        if (!payload.q) {
          return null;
        }

        return (payload.qField ? payload.qField + ': ' : '') + payload.q;
      };
      this.clearSearch = function() {
        delete payload.q;
        delete payload.qField;
      };
      this.hasSearch = function() {
        return !!payload.q;
      };

      /*=== Managed by me Filtering ===*/
      this.setOwnerFilter = function(ownerID) {
        payload.ownerId = ownerID;
      };

      this.getOwnerFilter = function() {
        return payload.ownerId;
      };

      this.hasOwnerFilter = function() {
        return payload.hasOwnProperty('ownerId');
      };

      this.clearOwnerFilter = function() {
        delete payload.ownerId;
      };

      /*=== Plan Type Filtering ===*/

      // Value is an array.
      // Each element is query param, key=value.
      // key=normalizedPlanTypes, value is either TEAM or EVIP (enterprise).
      // For example, normalizedPlanTypes=TEAM&planTypesToFilter=EVIP.
      this.setPlanTypeFilter = function(type) {
        if (!payload.normalizedPlanTypes) {
          payload.normalizedPlanTypes = [];
        }

        payload.normalizedPlanTypes.push(type);
      };

      this.clearPlanTypeFilter = function() {
        delete payload.normalizedPlanTypes;
      };

      // Return true if any plan type filter has been set in payload.
      this.hasPlanTypeFilter = function() {
        return Boolean(payload.normalizedPlanTypes);
      };

      // Return true if specified plan type filter has already been set in payload.
      var hasPlanType = function(type) {
        var found;

        var arr = payload.normalizedPlanTypes;
        if (arr) {
          found = arr.find(function(value) {
            return value === type;
          });
        }

        return Boolean(found);
      };

      this.hasPlanTypeFilterForTeam = function() {
        return hasPlanType(PLAN_TYPE.TEAM);
      };

      this.hasPlanTypeFilterForEnterprise = function() {
        return hasPlanType(PLAN_TYPE.ENTERPRISE);
      };
    }
  );
})();
